"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createNonEditableContentPlugin = exports.NonEditableContentElement = exports.ELEMENT_NON_EDITABLE_CONTENT = void 0;
var _react = _interopRequireDefault(require("react"));
var _plateCommon = require("@udecode/plate-common");
var _cn = require("@udecode/cn");
var _jsxRuntime = require("react/jsx-runtime");
var ELEMENT_NON_EDITABLE_CONTENT = exports.ELEMENT_NON_EDITABLE_CONTENT = 'non-editable-content';
var createNonEditableContentPlugin = exports.createNonEditableContentPlugin = (0, _plateCommon.createPluginFactory)({
  isElement: true,
  isInline: true,
  key: ELEMENT_NON_EDITABLE_CONTENT,
  then: function then(editor) {
    return {
      deserializeHtml: {
        getNode: function getNode(element) {
          var _element$getAttribute;
          return {
            hiddenValue: (_element$getAttribute = element.getAttribute('data-slate-value')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : '',
            type: (0, _plateCommon.getPluginType)(editor, ELEMENT_NON_EDITABLE_CONTENT)
          };
        },
        isLeaf: true,
        rules: [{
          validClassName: 'slate-' + ELEMENT_NON_EDITABLE_CONTENT,
          validAttribute: 'data-slate-value'
        }]
      }
    };
  }
});
var NonEditableContentElement = exports.NonEditableContentElement = (0, _cn.withRef)(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, ["children", "className", "onClick"]);
  var element = (0, _plateCommon.useElement)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_plateCommon.PlateElement, _objectSpread({
    ref: ref,
    as: "span",
    className: (0, _cn.cn)('inline-block rounded-md bg-muted px-1.5 py-0.5 align-baseline text-sm ', className),
    onClick: (0, _plateCommon.getHandler)(onClick, element),
    "data-slate-value": element.hiddenValue.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'),
    contentEditable: false
  }, props, {
    children: children
  }));
});